<ng-container *transloco="let t">
  @let items = items$ | async;
  @let isInputMode = isInputMode$ | async;
  <tui-loader [loading]="!items">
    @if (!!items?.length && !isInputMode) {
      <tui-textfield tuiChevron [content]="itemTemplate">
        <input
          data-testid="select"
          ngDefaultControl
          tuiSelect
          [disabled]="disabled"
          [ngModel]="value$ | async"
          [placeholder]="selectPlaceholder"
          (ngModelChange)="onValueChange($event)" />
        <tui-data-list *tuiDropdown>
          <tui-opt-group [label]="t('Numéros enregistrés')">
            @for (item of items; track item.id) {
              <button tuiOption type="button" [value]="item">
                <ng-content *ngTemplateOutlet="itemTemplate; context: { $implicit: item, hideFlag: true }" />
              </button>
            }
          </tui-opt-group>
          <tui-opt-group>
            <button data-testid="add-number-button" iconStart="@tui.plus" tuiOption type="button" [value]="null">
              {{ t('Ajouter un numéro') }}
            </button>
          </tui-opt-group>
        </tui-data-list>
      </tui-textfield>

      <ng-template #itemTemplate let-hideFlag="hideFlag" let-value>
        @if (!hideFlag) {
          <img
            class="mr-3 aspect-square h-7 rounded-full"
            [attr.alt]="countryIsoCode$ | async"
            [src]="countryIsoCode$ | async | tuiFlag" />
        }
        {{ value.phoneNumber | maskito: mask }}
      </ng-template>
    } @else {
      <div class="flex items-center gap-4">
        <tui-textfield class="flex-1">
          <input
            data-testid="input"
            ngDefaultControl
            placeholder="{{ inputPlaceholder }}"
            tuiInputPhoneInternational
            [countries]="(countries | tuiSortCountries) || []"
            [countrySearch]="true"
            [ngModel]="input"
            [(countryIsoCode)]="countryIsoCode"
            (ngModelChange)="onInput($event)" />
        </tui-textfield>
        @if (!!items?.length) {
          <button
            appearance="outline"
            data-testid="saved-numbers-button"
            size="l"
            tuiButton
            type="button"
            (click)="backToList()">
            {{ t('Numéros enregistrés') }}
          </button>
        }
      </div>
    }
  </tui-loader>
</ng-container>
